const enc = encodeURIComponent;
const dec = decodeURIComponent;
const DAY_MS = 24 * 60 * 60 * 1000;

function normalizeExpires(expires) {
if (expires == null) return null;
if (expires instanceof Date) return expires;
  if (typeof expires === 'number') {
    return new Date(Date.now() + expires * DAY_MS);
  }
  return null;
}

function get(name) {
  const target = `${enc(String(name))}=`;
  const list = document.cookie ? document.cookie.split('; ') : [];
  const match = list.find((item) => item.startsWith(target));
  return match ? dec(match.slice(target.length)) : undefined;
}

function set(name, value, options = {}) {
  const { path = '/', expires } = options;

  const parts = [`${enc(String(name))}=${enc(String(value))}`];

  const expDate = normalizeExpires(expires);
  if (expDate) parts.push(`Expires=${expDate.toUTCString()}`);
  if (path) parts.push(`Path=${path}`);

  document.cookie = parts.join('; ');
}

function remove(name, options = {}) {
  set(name, '', { ...options, expires: new Date(0) });
}

function has(name) {
  return get(name) !== undefined;
}

const Cookies = { get, set, remove, has };
export default Cookies;
